import { render } from "./StagesNew.vue?vue&type=template&id=5963ecae&scoped=true&lang=pug"
import script from "./StagesNew.vue?vue&type=script&lang=js"
export * from "./StagesNew.vue?vue&type=script&lang=js"

import "./StagesNew.vue?vue&type=style&index=0&id=5963ecae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5963ecae"]])

export default __exports__